<template>
  <div v-if="applicationTemplate" class="row application-form">
    <div v-if="note && note !== ''" v-html="note.includes('[examFee]') && user.currency=='GEL'?note.replace('[examFee]','200 GEL'):note.includes('[examFee]') && user.currency=='USD'?note.replace('[examFee]','200 USD'):note" class="col-12 my-4"></div>
    
    <div v-if="applicationTemplate.receivers && applicationTemplate.receivers.length > 1" class="col-12">
        <label for="receivers">{{$t('applications.new.application-receivers')}}</label>
        <multiselect
                id="receivers"
                v-model="receiver"
                :options="applicationTemplate.receivers"
                track-by="application_recieverID"
                :label="locale === 'ka' ? 'receiver_title' : 'receiver_titleeng'"
                :placeholder="$t('applications.new.choose-application-receivers')"
        ></multiselect>
          
    </div>
   
 
    <div v-if="!applicationTemplate.receivers || applicationTemplate.receivers.length <= 1 || receiver" class="col-12">
      <div class="template-content mt-5">
        <div class="text-right" v-if="receiver" v-html="helpers.getLocalizedField(receiver, 'head')"></div>
        <template v-for="(content, key) of templateContent">

         

            <span class="mb-2" v-if="content.type === 'text'" v-html="content.content"></span>
            <template v-if="content.type === 'input'">
              <input-textarea
                @input="handleTextInput($event, key, content.id)"
                v-if="getTemplateInput(content.id).type === 'textarea'"
                :placeholder="helpers.getLocalizedField(getTemplateInput(content.id), 'description')"></input-textarea>
              <input-text
                @input="handleTextInput($event, key, content.id)"
                v-if="getTemplateInput(content.id).type === 'text'"
                :placeholder="helpers.getLocalizedField(getTemplateInput(content.id), 'description')"></input-text>
              <input-date
                @input="handleTextInput($event, key, content.id)"
                v-if="getTemplateInput(content.id).type === 'date'"
                :placeholder="helpers.getLocalizedField(getTemplateInput(content.id), 'description')"></input-date>
              <input-file
                @input="handleFileInput($event, key, content.id)"
                v-if="getTemplateInput(content.id).type === 'file'"
                :placeholder="helpers.getLocalizedField(getTemplateInput(content.id), 'description')"></input-file>
              <input-select
              :contentid="content.id"
                @input="handleSelectInput($event, key, content.id)"
                v-if="getTemplateInput(content.id).type === 'select'"
                :placeholder="helpers.getLocalizedField(getTemplateInput(content.id), 'description')"
                :data="content.id == 18 ? lectureWeekData:content.id==62?lectureWeekData2 : getTemplateInput(content.id).data"></input-select>

               

            </template>
            
        </template>
        <br><br>
       
        <div  v-if="applicationTemplate.hasOnline==1">
        <input type="checkbox"    @click="handleCheckBox()"/><span > {{ $t('applications.new.text') }}: {{ user.email_UG }} </span>
        <br>
        <br>
        <br>
        <br>
        <div style="display: flex; align-items: center;">


             <div >
              
                  <input type="checkbox"    @click="handleCheckBoxPersonalEmail()"/> {{ $t('applications.wantOnPersonal') }}
                 
           </div>

             <div class="ml-1" style="width: 45%;">
               <input :disabled="personalEmailDisabled" class="form-control" type="email" v-model="personalEmail" :placeholder="$t('applications.personalEmail')">
          </div>
           
         </div>
        
        
        </div>
      </div>
      <div class="mt-4 text-center">
      
        <button
         :disabled="!accountNumberCheck || !accountOwnerCheck"
          v-if="!sent"
          @click="handleSendClick"
          class="btn btn-primary-red">{{ $t('applications.new.send-application') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import ApplicationResource from '../../api/applicationResource';
import InputTextarea from './templates/input-textarea';
import InputText from './templates/input-text';
import InputDate from './templates/input-date';
import InputFile from './templates/input-file';
import InputSelect from './templates/input-select';

const applicationResource = new ApplicationResource();
const lectureWeekInputNumber = 18;

export default {
  name: 'application-form',

  components: { Multiselect, InputTextarea, InputText, InputDate, InputFile, InputSelect },

  props: ['application-template-id'],

  watch: {
      '$i18n.locale'(newLocale, oldLocale) {
       this.loadApplicationTemplate();
    },
    applicationTemplateId() {
      this.receiver = null;
      this.loadApplicationTemplate();
      this.applicationForm = new FormData();
      
    },
    applicationTemplate(val){
     
              if(val.application_templateID==12){
                
                this.accountNumberCheck=false
                this.accountOwnerCheck=false
              }else{
                    this.accountNumberCheck=true
                this.accountOwnerCheck=true
              }
    },

    locale() {
      window.location.reload();
    },

   
  },

  computed: {
    ...mapGetters({
      locale: 'language/locale',
      user:'auth/user'
    }),
    note() {
      return this.helpers.getLocalizedField(this.applicationTemplate, 'notification');
    }
  },

  mounted() {
    this.loadApplicationTemplate();
  },

  data() {
    return {
      applicationTemplate: null,
      receiver: null,
      templateContent: [],
      applicationForm: new FormData(),
      sent: false,
      lectureWeekData: [],
      lectureWeekData2: [],
      checkboxChecked:false,
      accountNumberCheck:false,
      accountOwnerCheck:false,
      personalEmail:null,
      personalEmailDisabled:true
    }
  },

  methods: {


    handleCheckBoxPersonalEmail(){
        this.personalEmailDisabled=!this.personalEmailDisabled
    },


    handleCheckBox(){

      this.checkboxChecked=!this.checkboxChecked 
    },












    handleTextInput(text, key, inputId) {

      if(this.applicationTemplateId==12){
            if(inputId==55){
              if(text.length==22){
              this.accountNumberCheck=true
            }else {
              this.accountNumberCheck=false
            }
    }


       if(inputId==60){
        if(text.length>0){
         this.accountOwnerCheck=true
      }else {

         this.accountOwnerCheck=false
      }
    }
    }else {
        this.accountNumberCheck=true
      this.accountOwnerCheck=true

    }
 


      this.applicationForm.append('inputs[' + key + '][id]', inputId);
      this.applicationForm.append('inputs[' + key + '][value]', text);
    },
    handleFileInput(file, key, inputId) {
      this.applicationForm.append('inputs[' + key + '][id]', inputId);
      this.applicationForm.append('inputs[' + key + '][value]', file);
    },
   handleSelectInput(option, key, inputId) {
  // 1. Clear any previously appended data for this specific key to avoid duplicates
  // (Optional, but highly recommended if users change their minds and re-select options)
  this.applicationForm.delete('inputs[' + key + '][id]');
  this.applicationForm.delete('inputs[' + key + '][value][id]');
  this.applicationForm.delete('inputs[' + key + '][value][value]');

  // If nothing is selected, stop here
  if (!option || (Array.isArray(option) && option.length === 0)) {
    return;
  }

  // 2. Check if the incoming data is an array (Multiple mode active)
  if (Array.isArray(option)) {
    option.forEach((singleOption) => {
      const value = this.locale === 'ka' ? singleOption.value : singleOption.valueeng;
      
      this.applicationForm.append('inputs[' + key + '][id]', inputId);
      // Brackets [] are often needed in Formdata keys for array values depending on backend setup
      this.applicationForm.append('inputs[' + key + '][value][id][]', singleOption.id);
      this.applicationForm.append('inputs[' + key + '][value][value][]', value);
    });
  } 
  // 3. Otherwise, treat it as a single object (Single mode active)
  else {
    const value = this.locale === 'ka' ? option.value : option.valueeng;
    
    this.applicationForm.append('inputs[' + key + '][id]', inputId);
    this.applicationForm.append('inputs[' + key + '][value][id]', option.id);
    this.applicationForm.append('inputs[' + key + '][value][value]', value);

    // This logic only applies to single mode as per your original id logic
    if (this.applicationTemplateId == 50 && inputId == 2) {
      this.loadLectureWeekData(option.id);
    }
        if (this.applicationTemplateId == 72 && inputId == 2) {
      this.loadLectureWeekData2(option.id);
    }
  }
},

    loadLectureWeekData(subjectId) {
      applicationResource.loadInputData(this.applicationTemplateId, lectureWeekInputNumber, subjectId).then(response => {
        this.lectureWeekData = response.data.data;
      });
    },

    
    loadLectureWeekData2(subjectId) {
      applicationResource.loadInputData(this.applicationTemplateId, 62, subjectId).then(response => {
        this.lectureWeekData2 = response.data.data;
      });
    },

    handleSendClick() {
     
      this.applicationForm.append('template_id', this.applicationTemplateId);
      this.applicationForm.append('wantOnEmail', this.checkboxChecked);
      this.applicationForm.append('personalEmail', this.personalEmail);

      if(this.receiver)
        this.applicationForm.append('application_receiver_id', this.receiver.application_recieverID);

      this.sent = true;
      applicationResource.writeApplication(this.applicationForm)
      .then(response => {

        if(this.applicationTemplateId==53){
          this.helpers.notifySuccessMessage('გთხოვთ შეხვიდეთ თქვენს ug.edu.ge-ს მეილზე და გადახვიდეთ გამოგზავნილ ლინკზე რათა დაადასტუროთ განცხადების გაგზავნა / Please log in to your ug.edu.ge email and follow the link sent to confirm the application.');

        }else {
          this.helpers.notifySuccessMessage(this.$t('applications.new.success'));

        }


        

        this.applicationTemplate = null;
        this.receiver = null;
        this.templateContent = [];
        this.lectureWeekData = [];

        this.$router.push('/my-applications');
      })
      .catch(error => {
        this.sent = false;
        this.helpers.notifyErrorMessage(error);
      });
    },

    loadApplicationTemplate() {
      applicationResource.applicationTemplate(this.applicationTemplateId)
          .then(response => {
            this.applicationTemplate = response.data.data;
            this.lectureWeekData = [];

            if(this.applicationTemplate.receivers.length === 1) {
              this.receiver = this.applicationTemplate.receivers[0];
            }

            this.generateTemplateContent();
          })
    },

    getTemplateInput(id) {
      return this.applicationTemplate.inputs.find(o => o.input_number == id);
    },

    generateTemplateContent() {
      const expression = new RegExp('\\[([0-9]+]*)]','g');
      const string = this.helpers.getLocalizedField(this.applicationTemplate, 'input_text');
      let matches = [...string.matchAll(expression)];

      let templateContent = [];
      let lastPosition = 0;
      for(let match of matches) {
        templateContent.push({
          'type': 'text',
          'content': string.substring(lastPosition, match.index)
        });

        templateContent.push({
          'type': 'input',
          'id': match[1]
        });

        lastPosition = match.index + match[0].length;
      }

      if(lastPosition < string.length)
        templateContent.push({
          'type': 'text',
          'content': string.substring(lastPosition, string.length)
        });

      this.templateContent = templateContent;
    }
  }
};
</script>

<style scoped>
  .application-form {
      font-size: 14px;
  }
</style>
